webpackJsonp([28,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _userServices = __webpack_require__(25);
	
	var _userServices2 = _interopRequireDefault(_userServices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Shared = __webpack_require__(8);
	var LanguageManager = __webpack_require__(6);
	var utils = __webpack_require__(2);
	var log = __webpack_require__(4)();
	var LoginManager = __webpack_require__(146);
	var StorageController = __webpack_require__(21);
	var FormValidator = __webpack_require__(33);
	var Constants = __webpack_require__(55);
	
	__webpack_require__(597);
	
	$(function () {
	  Shared.init();
	  LoginPage.init();
	});
	
	var LoginPage = {};
	
	(function (LoginPage) {
	  var loginFormValidator = null;
	
	  var LOGIN_BTN_ID = "#login-btn";
	  var USERNAME_INPUT_ID = "#login-username-input";
	  var PASSWORD_INPUT_ID = "#login-password-input";
	  var LINK_BOARDCODE_INPUT = "#link-boardcode-input";
	  var LINK_BOARDCODE_BTN = "#link-boardcode-btn";
	  var LINK_BOARDCODE_BACK_BTN = "#link-boardcode-back-btn";
	
	  LoginPage.init = function () {
	    setUpLoginForm();
	    setUpEventListeners();
	
	    clearAllFieldErrors();
	
	    showLoginPart();
	  };
	
	  function setUpEventListeners() {
	    $(LOGIN_BTN_ID).on("click", function (e) {
	      var $this = $(this);
	
	      var isValid = loginFormValidator.validate();
	
	      if (isValid) {
	        $this.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	        login().finally(function () {
	          $this.prop("disabled", false).removeClass("btn-loading");
	        });
	      }
	    });
	
	    $(USERNAME_INPUT_ID).on("input", function (e) {
	      $(this).removeClass("input-error");
	    });
	
	    $(PASSWORD_INPUT_ID).on("input", function (e) {
	      $(this).removeClass("input-error");
	    });
	
	    $(PASSWORD_INPUT_ID).on("keyup", function (e) {
	      if (e.keyCode === 13) {
	        $(this).blur();
	        login();
	      }
	    });
	
	    // only enable login button if a username and password is filled in
	    $("#login-username-input, #login-password-input").on("keyup", function () {
	      $("#login-username-input-error").text("");
	
	      var usernameInput = $("#login-username-input");
	      var passwordInput = $("#login-password-input");
	
	      if (utils.isNullOrEmpty(usernameInput.val()) || utils.isNullOrEmpty(passwordInput.val())) {
	        $(LOGIN_BTN_ID).prop("disabled", true);
	      } else {
	        $(LOGIN_BTN_ID).prop("disabled", false);
	      }
	    });
	
	    // link boardcode
	
	    $(LINK_BOARDCODE_INPUT).on("input", function (e) {
	      $(LINK_BOARDCODE_INPUT).removeClass("is-invalid");
	    });
	
	    $(LINK_BOARDCODE_BTN).on("click", function (e) {
	      linkBoardcode();
	    });
	
	    $(LINK_BOARDCODE_BACK_BTN).on("click", function (e) {
	      showLoginPart();
	    });
	
	    Shared.setupGameboardCodeInput("#link-boardcode-input");
	  }
	
	  function setUpLoginForm() {
	    loginFormValidator = new FormValidator({
	      selector: "#login-form",
	      validateOnChange: true,
	      rules: {
	        username: {
	          validator: function validator(username) {
	            return !utils.isNullOrEmpty(username) && username.trim() !== "";
	          }
	        },
	        password: {
	          validator: function validator(password) {
	            return !utils.isNullOrEmpty(password) && password.trim() !== "";
	          }
	        }
	      }
	    });
	
	    log.info(loginFormValidator);
	  }
	
	  function clearAllFieldErrors() {
	    $(".form-control").removeClass("is-invalid");
	    $(".input-field-error").text("");
	  }
	
	  function login() {
	    if (utils.isNull(loginFormValidator)) return;
	
	    $("#login-error-msg").empty();
	
	    clearAllFieldErrors();
	
	    var formData = loginFormValidator.getFormData();
	
	    var username = formData.username,
	        password = formData.password;
	
	    return LoginManager.login(username, password).then(function (data) {
	      var loginData = data.loginData,
	          referer = data.referer;
	
	      StorageController.saveToLocal(StorageController.keys.LOGGED_IN_USER, loginData);
	
	      log.info("Referer: %s", referer);
	
	      //if this is the first time the user logs in, redirect to profile setup
	      if (data.userData.lastAuthenticated === null) {
	        utils.redirect("/profile-setup-picture");
	      } else {
	        //if(!utils.isNullOrEmpty(referer) && referer.includes("/login"))
	        if (!utils.isNullOrEmpty(referer)) {
	          utils.redirect("/sessions");
	        } else {
	          utils.redirect(referer);
	        }
	      }
	    }).catch(function (appError) {
	      log.error("Login failed");
	
	      if (appError.code === Constants.APP_ERROR_USER_NOT_LINKED_TO_GAMEBOARD) {
	        showLinkCodePart();
	        return;
	      }
	
	      var message = LanguageManager.getValueForKey(appError.code);
	      switch (appError.code) {
	        case Constants.PASSWORD_INCORRECT:
	          $("#login-password-input-error").text(message);
	          $("#login-password-input").addClass("is-invalid");
	          return;
	        default:
	          $("#login-username-input-error").text(message);
	          $("#login-username-input").addClass("is-invalid");
	      }
	    });
	  }
	
	  function linkBoardcode() {
	    clearAllFieldErrors();
	
	    var input = $("#link-boardcode-input").removeClass("is-invalid");
	    var code = input.val();
	    var email = $("#login-username-input").val();
	
	    if (utils.isNullOrEmpty(code)) {
	      input.addClass("is-invalid");
	      return;
	    }
	
	    var $btn = $(LINK_BOARDCODE_BTN);
	    $btn.prop("disabled", true).removeClass("btn-loading").addClass("btn-loading");
	
	    _userServices2.default.linkGameboard(email, code).then(function (data) {
	      input.val("");
	      login();
	    }).catch(function (appError) {
	      input.addClass("is-invalid");
	      var errorMessage = LanguageManager.getValueForKey(appError.code);
	      $("#link-boardcode-input-error").html(errorMessage);
	    }).finally(function () {
	      $btn.prop("disabled", false).removeClass("btn-loading");
	    });
	  }
	
	  function showLoginPart() {
	    $("#part-login").show();
	    $("#part-register").show();
	    $("#part-link-boardcode").hide();
	  }
	
	  function showLinkCodePart() {
	    $("#part-login").hide();
	    $("#part-register").hide();
	    $("#part-link-boardcode").show();
	  }
	})(LoginPage);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 11
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 10;


/***/ }),

/***/ 597:
107

});


// WEBPACK FOOTER //
// js/login.577a45c390c1da237439.js